import { lazy } from 'react';

// Page types are loaded on demand so each one gets its own chunk. Home, Page and Error stay in the
// initial bundle: Routes and LoaderPage import them directly.
const Magazine = lazy(() => import('./Magazine'));

export const ContactUs = lazy(() => import('./ContactUs'));
export const Contact = lazy(() => import('./Contact'));
export const District = lazy(() => import('./District'));
export const Event = lazy(() => import('./Event'));
export const ListContacts = lazy(() => import('./ListContacts'));
export const ListDistricts = lazy(() => import('./ListDistricts'));
export const ListMagazines = lazy(() => import('./ListMagazines'));
export const ListEvents = lazy(() => import('./ListEvents'));
export {
    Magazine,
    Magazine as MagazineVideo,
    Magazine as MagazinePhoto,
    Magazine as MagazinePodcast,
};
export const Newsletter = lazy(() => import('./Newsletter'));
export const Splash = lazy(() => import('./Splash'));
export { default as Error } from './Error';
export { default as Page } from './Page';
